import React from 'react';
import { Link } from 'react-router-dom';
const Projects = ({title,link,para,img}) => {
  return (
    <>
    
    
    <div className='mx-[100px] h-[600px]' id="Projects">
      
      <div className='bg-[#ffffff] w-[250px] h-[350px] rounded-xl my-[40px] shadow-2xl'>
        <img src={img} className="rounded-lg"/>
        <h1 className='text-black text-[30px] text-center'>{title}</h1>
        <p className='text-[#8f8d8d] text-center text-[14px]'>Lorem{para}</p>
        <div className='flex justify-center'>
          <a href={link}>
            <button className='bg-[#E5038B] shadow-xl text-[white] h-[50px] w-[100px] rounded-2xl'>view</button>
          </a>
        
        </div>
      </div>
    </div>
    </>
    
  )
}

export default Projects